"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMoment = _interopRequireDefault(require("react-moment"));

require("moment-timezone");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateTime = function DateTime(_ref) {
  var children = _ref.children,
      format = _ref.format,
      locale = _ref.locale,
      isUTC = _ref.isUTC,
      timezone = _ref.timezone;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMoment.default, {
    utc: isUTC,
    local: isUTC,
    date: children,
    format: format || "ddd Do MMM - h:mm a",
    locale: locale || "en-gb",
    tz: timezone
  });
};

var _default = DateTime;
exports.default = _default;